/**
 * This code was generated by Builder.io.
 */
import React, { useEffect } from "react";
import styles from "./TitleServicePreQualification.module.css";
// import BenefitCard from "./BenefitCard";
import { useNavigate } from "react-router-dom";
import Header from "../../Header/Header";
import ShakeHands from "../../../assets/images/shake-hands.png";
import EfficiencyTransparency from "../../../assets/svg/EfficiencyTransparency.svg";
import ExpertGuidance from "../../../assets/svg/ExpertGuidance.svg";
import UnmatchedSecurity from "../../../assets/svg/UnmatchedSecurity.svg";
import BenefitCard from "../../GetQualified/FinancialPreQualification/BenefitCard";
import config from "../../../config";

const TitleService = () => {
    const benefits = [
        {
            iconSrc: ExpertGuidance,
            title: "Expert Guidance",
            description: "Reliable title searches, insurance options, and legal support.",
        },
        {
            iconSrc: EfficiencyTransparency,
            title: "Efficiency & Transparency",
            description: "Stay informed with real-time updates.",
        },
        {
            iconSrc: UnmatchedSecurity,
            title: "Unmatched Security",
            description: "Industry-leading professionals ensure your property rights are protected.",
        },
    ];
    const navigate = useNavigate();
    const handleGetQualifiedClick = () => {
        navigate("/get-title/Step-1");
    };

    useEffect(() => {
        document.title = `Title Service | ${config.get("COMPANY_NAME")}`;
    }, []);

    return (
        <div className={`${styles.container} tw-bg-background_color`}>
            <main className={`${styles.mainContent} tw-overflow-y-auto`}>
                {/* <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/0bbafeda80572fe08294a1d09a0d5e5d56d369a649532326f010c638f91f9cd4?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                    alt=""
                    className={styles.backgroundImage}
                /> */}
                <Header title="Apply For Title Services" />
                <div></div>
                <section className={`${styles.contentWrapper} tw-px-3 `}>
                    <div className={`${styles.titleSection}`}>
                        <h2 className={styles.mainTitle}>Protect Your Property Rights with Confidence</h2>
                        <p className={`${styles.subtitle}  tw-mt-2`}>Seamless title services and legal expertise for a hassle-free transaction.</p>
                    </div>
                    <div className={`${styles.benefitsContainer}`}>
                        {benefits.map((benefit, index) => (
                            <BenefitCard key={index} {...benefit} />
                        ))}
                    </div>
                    <p className="tw-mt-5">A clear title is the foundation of a secure property transaction. Let us help you build on solid ground</p>
                    <div className={styles.ctaWrapper}>
                        <button
                            onClick={handleGetQualifiedClick}
                            className={`${styles.ctaButton} max-sm:tw-w-full  tw-bg-primary hover:tw-bg-primary_hover`}
                        >
                            <div className={styles.ctaContent}>
                                <span className={`${styles.ctaText} tw-font-normal `}>Start Your Title Protection Journey</span>
                                {/* <img
                                    loading="lazy"
                                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/227c2b2ca3dd3641e394eac2f3900a38798cd114c7922b5d5778eab665534f03?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                                    alt=""
                                    className={styles.ctaIcon}
                                /> */}
                            </div>
                        </button>
                    </div>
                </section>
                <footer className={styles.footerWrapper}>
                    <p className={styles.footerText}>Your information is safe and secure with us.</p>
                    <a onClick={() => navigate("/privacy-policy")} className={styles.footerLink}>
                        Learn more about our privacy policy
                    </a>
                </footer>
            </main>
        </div>
    );
};

export default TitleService;
